import { cartAmountsReducer } from "../AddToCart/redux/cartAmounts/reducer";
import { srpReducer } from "../Search/redux/reducer";
import { cartPageReducer } from "~/feature/cart/cart/redux/reducers/cartPageReducer";
import { checkoutPageReducer } from "~/feature/cart/cart/redux/reducers/checkoutPageReducer";
import { cartReducer } from "~/feature/cart/cart/redux/reducers/cartReducer";
import { globalMessagesReducer } from "./globalMessages/reducer";
import { productsReducer } from "./products/reducer";
import { contractsReducer } from "../Contracts/redux/reducer";
import { wishlistReducer } from "../Wishlist/redux/wishlistReducer";
import { productDetailsPageReducer } from "../ProductDetails/redux/productDetailsReducer";
import { navigationReducer } from "../Header/redux/reducer";
import { linearConfiguratorReducer } from "../Configurators/Linear/redux/reducer";
import { externalContentReducer } from "./externalContent/reducer";

import { productComparisonReducer } from "../ProductComparison/redux/reducer";
import { regionSelectionBannerReducer } from "../RegionSelectionBanner/reducer";
import { HOUSING_SA_REDUCER } from "../HousingSelectionAssistant/redux/reducer";
import { notificationsReducer } from "../Notifications/redux/NotificationsReducer";
import { saReducer } from "~/BearingSelectionAssistant/redux/reducer";
import { minicartReducer } from "~/feature/cart/cart/components/Minicart/minicartRedux";
import { affiliateReducer } from "~/feature/Affiliate/redux/reducer";
import { searchQueryReducer } from "~/Header/components/headerMenu/Autosuggest/redux/reducer";
import { navigationBreadcrumbsReducer } from "~/jspComponents/Breadcrumbs/redux/reducer";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userPreferencesReducer from "~/feature/UserPreferences/userPreferencesSlice";

const rootReducer = combineReducers({
  cartPage: cartPageReducer,
  checkoutPage: checkoutPageReducer,
  cart: cartReducer,
  globalMessages: globalMessagesReducer,
  products: productsReducer,
  cartAmounts: cartAmountsReducer,
  linearConfigurator: linearConfiguratorReducer,
  regionSelectionBanner: regionSelectionBannerReducer,
  navigationBreadcrumbs: navigationBreadcrumbsReducer,

  contracts: contractsReducer,
  wishlistPage: wishlistReducer,

  srp: srpReducer,
  pdp: productDetailsPageReducer,
  sa: saReducer,
  navigation: navigationReducer,

  externalContent: externalContentReducer,
  productComparison: productComparisonReducer,
  housingSA: HOUSING_SA_REDUCER,
  userPreferences: userPreferencesReducer,

  notifications: notificationsReducer,

  minicart: minicartReducer,

  affiliate: affiliateReducer,

  search: searchQueryReducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    // @ts-expect-error
    preloadedState,
  });
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
